import Button from "Components/button/button";
import classNames from "classnames";
import React, { memo, useCallback, useEffect, useRef, useState } from "react";
import { ProgressScale } from "../progressBar";
import SpeedTrackSelect from "./speedTrackSelect";
function Controls(props) {
    const { mediaRef, progressBarRef, setTimeProgress } = props;
    const [isPlaying, setIsPlaying] = useState(false);
    const [volume, setVolume] = useState({
        current: 60,
        previous: 0
    });
    const handleTogglePlayPause = useCallback(() => {
        setIsPlaying(prev => !prev);
    }, []);
    const playAnimationRef = useRef();
    const repeat = useCallback(() => {
        const { currentTime } = mediaRef.current || { currentTime: 0 };
        setTimeProgress(currentTime);
        if (progressBarRef.current) {
            progressBarRef.current.value = currentTime.toString();
        }
        playAnimationRef.current = requestAnimationFrame(repeat);
    }, [playAnimationRef, progressBarRef, mediaRef]);
    const handleVolumeToggleMute = useCallback(() => {
        setVolume(prev => prev.current
            ? {
                current: 0,
                previous: prev.current
            }
            : {
                ...prev,
                current: prev.previous
            });
    }, []);
    const handleSkipBackward = useCallback(() => {
        if (mediaRef.current)
            mediaRef.current.currentTime -= 15;
    }, [mediaRef]);
    const handleSkipForward = useCallback(() => {
        if (mediaRef.current)
            mediaRef.current.currentTime += 15;
    }, [mediaRef]);
    useEffect(() => {
        if (isPlaying && mediaRef.current) {
            mediaRef.current.play();
            playAnimationRef.current = requestAnimationFrame(repeat);
        }
        else if (mediaRef.current) {
            mediaRef.current.pause();
        }
    }, [isPlaying, mediaRef, repeat]);
    useEffect(() => {
        if (mediaRef.current) {
            mediaRef.current.volume = volume.current / 100;
        }
    }, [volume.current, mediaRef]);
    useEffect(() => {
        if (mediaRef.current) {
            mediaRef.current.muted = !volume.current;
        }
    }, [mediaRef, Boolean(volume.current)]);
    const handlePlaybackRateChange = useCallback((speed) => {
        if (mediaRef.current)
            mediaRef.current.playbackRate = speed;
    }, [mediaRef]);
    const handleChangeVolume = useCallback((e) => setVolume(prev => ({ ...prev, current: Number(e.target.value) })), []);
    return (React.createElement("div", { className: "bg-gray-650" },
        React.createElement("div", { className: "d-flex justify-content-center border-top-gray-600" },
            React.createElement("div", { className: "flex-space-between bg-gray-650" },
                React.createElement("div", { className: "d-flex" },
                    React.createElement(SpeedTrackSelect, { handlePlaybackRateChange: handlePlaybackRateChange }),
                    React.createElement(Button, { className: "flex-box-centered-content no-border bg-gray-650 clickable", onClick: handleSkipBackward, minWidth: 55 },
                        React.createElement("i", { className: "icon-backward font-h2" })),
                    React.createElement(Button, { className: "flex-box-centered-content no-border bg-gray-650 clickable", onClick: handleTogglePlayPause, minWidth: 55 },
                        React.createElement("i", { className: isPlaying ? "icon-pause font-h2" : "icon-play font-h2" })),
                    React.createElement(Button, { className: "flex-box-centered-content no-border bg-gray-650 clickable", onClick: handleSkipForward, minWidth: 55 },
                        React.createElement("i", { className: "icon-forward font-h2" }))),
                React.createElement(Button, { className: "flex-box-centered-content no-border bg-gray-650 clickable", onClick: handleVolumeToggleMute, minWidth: 55 },
                    React.createElement("i", { className: classNames(volume.current ? "icon-volume" : "icon-volume-mute", "font-h2") })),
                React.createElement(ProgressScale, { min: 0, max: 100, value: volume.current, onChange: handleChangeVolume })))));
}
export default memo(Controls);
